import { useReducer } from "react";

export default function useComplexState(initState = {}) {
    return useReducer((state, newState) => ({ ...state, ...newState }), initState);
}
